import React from "react";
import car from "../images/components/car.svg";

function NoFoundVehicles({ title }) {
  return (
    <div className="not-found-wrapp">
      <img src={car} alt="" />"{title}""
    </div>
  );
}

export default NoFoundVehicles;
